/** @format */

export const DATE_INPUT_REGEX = /^\d{1,2}\.\d{1,2}\.\d{4}$/;
export const TIME_INPUT_REGEX = /^((24\.00)|(([0-9]|0[0-9]|1[0-9]|2[0-3])\.[0-5][0-9]))$/;
export const MOMENT_DATE_DISPLAY_FORMAT = 'D.M.YYYY';
export const MOMENT_TIME_DISPLAY_FORMAT = 'H.mm';
export const MOMENT_DATE_TIME_DISPLAY_FORMAT = `${MOMENT_DATE_DISPLAY_FORMAT} ${MOMENT_TIME_DISPLAY_FORMAT}`;
export const DATEPICKER_FORMAT = 'dd.MM.yyyy';
export const ISO_LOCAL_DATE_FORMAT = 'YYYY-MM-DD';
export const ISO_LOCAL_TIME_FORMAT = 'HH:mm';
export const ISO_LOCAL_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm';
